exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".picker-container[data-v-1edbef7f]{width:320px;max-height:60vh}.is-selected[data-v-1edbef7f]{background:var(--secondary);color:#fff;border-radius:.25em}@media(max-width:600px){.picker-container[data-v-1edbef7f]{width:100%;padding-left:24px;padding-right:24px}.picker-body[data-v-1edbef7f]{max-width:320px}.month-trigger[data-v-1edbef7f]{border:1px solid #dcdcdc}}", ""]);

// exports
